<template>
  <div>
    <Header :ifblueme="ifblueme"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box" v-if="member">
            <div class="test-head">
              <span v-for="(c,index) in cate" ref="Constitution" :key="index" :id="c.id" :class="{'test-title-on':c.id==ifSelection,'test-title-off':c.id!==ifSelection}" @click="viceNavigation($event)">{{c.title}}</span>
            </div>
            <ul class="test-ul">
              <item-member v-for="(m,index) in member" :key="index" :img="m.head" :name="m.name"></item-member>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemMember from '@/components/item/itemMember.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'member',
  data () {
    return {
      // 所在页面的名称
      topName: 'member',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/member',
      secondtest: '会员地址',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: []
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemMember: itemMember
  },
  methods: {
    // 副导航栏点击
    viceNavigation (event) {
      console.log(event)
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        console.log(res)
        this.member = res.member
        this.cate = res.cate
      })
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      this.ifSelection = res.cate[0].id
      this.member = res.member
      this.cate = res.cate
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  /* .test-head span:nth-child(n+2){
    float: left;
  } */
  .test-ul{
    margin-left: 0px;
    list-style: none;
    overflow: hidden;
  }
  .test-title{
    font-size: 14px
  }
  .test-title-on{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #0051bd;
  }
  .test-title-off{
    font-size: 14px;
    margin: 0px 5px;
    cursor:pointer;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/member.vue